import { render } from "./WorkSpace.vue?vue&type=template&id=35bf57fc&scoped=true"
import script from "./WorkSpace.vue?vue&type=script&lang=js"
export * from "./WorkSpace.vue?vue&type=script&lang=js"

import "./WorkSpace.vue?vue&type=style&index=0&id=35bf57fc&scoped=true&lang=css"

import exportComponent from "D:\\PDM-小程序\\HSM_PDM\\PDM_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bf57fc"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QCard,QCardSection,QAvatar,QBtn,QIcon,QSpace,QSeparator,QItemLabel,QCardActions,QDrawer,QToolbar});
